export type FormType =
  | 'import-team-structure'
  | 'import-users'
  | 'import-components'
  | 'import-targets'
  | 'import-team-actuals'
  | 'import-employee-actuals'
  | 'import-rewards'
  | 'import-user-rewards'

export interface SnackbarState {
  open: boolean
  message: string
  details?: string[] | string
  severity: 'success' | 'error'
}

export const FORM_TYPE_MAP: Record<FormType, string> = {
  'import-team-structure': 'TEAM_STRUCTURE',
  'import-users': 'USERS',
  'import-components': 'COMPONENTS',
  'import-targets': 'TARGETS',
  'import-team-actuals': 'TEAM_ACTUALS',
  'import-employee-actuals': 'EMPLOYEE_ACTUALS',
  'import-rewards': 'REWARDS',
  'import-user-rewards': 'USER_REWARDS',
}

export const REQUIRED_SELECTORS: Record<FormType, string[]> = {
  'import-team-structure': [],
  'import-users': [],
  'import-components': [],
  'import-targets': ['organization', 'period'],
  'import-team-actuals': ['organization', 'period'],
  'import-employee-actuals': ['organization', 'period'],
  'import-rewards': [],
  'import-user-rewards': ['organization', 'rootPeriod', 'package'],
}

export const DOWNLOAD_FORM_TYPE_OPTIONS = [
  { value: 'import-team-structure', label: 'Team Structure Form' },
  { value: 'import-users', label: 'Users Form' },
  { value: 'import-components', label: 'Components Form' },
  { value: 'import-targets', label: 'Targets Form' },
  { value: 'import-team-actuals', label: 'Team Actuals Form' },
  { value: 'import-employee-actuals', label: 'Employee Actuals Form' },
  { value: 'import-rewards', label: 'Rewards Form' },
  { value: 'import-user-rewards', label: 'Employee Rewards Form' },
] as const

export const UPLOAD_FORM_TYPE_OPTIONS = [
  { value: 'import-team-structure', label: 'Import Team Structure Form' },
  { value: 'import-users', label: 'Import Users Form' },
  { value: 'import-components', label: 'Import Components Form' },
  { value: 'import-targets', label: 'Import Targets Form' },
  { value: 'import-team-actuals', label: 'Import Team Actuals Form' },
  { value: 'import-employee-actuals', label: 'Import Employee Actuals Form' },
  { value: 'import-rewards', label: 'Import Rewards Form' },
  { value: 'import-user-rewards', label: 'Import Employee Rewards Form' },
] as const

// Keep the original for backward compatibility
export const FORM_TYPE_OPTIONS = UPLOAD_FORM_TYPE_OPTIONS
